import { createAsyncThunk } from '@reduxjs/toolkit';
import { ApiContracts } from 'modules/api';

export const fetchContractByNumber = createAsyncThunk(
  'contract/fetchContracts',
  async (number: string, { rejectWithValue }) => {
    try {
      const response = await ApiContracts.getContractByNumber(number);
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);
